<template>
  <div v-if="shouldShow">
    <v-menu
      bottom
      left
      offset-y
      eager
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          v-bind="attrs"
          v-on="on"
          class="mobile-menu-activator"
        >
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>

      <v-list class="mobile-menu">
        <!-- Language Section -->
        <v-list-item class="mobile-menu-section">
          <v-list-item-content>
            <v-list-item-title class="mobile-menu-title">{{ $t('layout.header.menu.language') }}</v-list-item-title>
            <div class="language-buttons">
              <v-btn
                v-for="(item, index) in languages"
                :key="index"
                @click="changeLang(item.value)"
                tile
                plain
                :class="item.value === currentLanguage ? 'as-active-language' : ''"
                class="lang-btn"
              >
                {{ item.text }}
              </v-btn>
            </div>
          </v-list-item-content>
        </v-list-item>

        <v-divider v-if="!isLoggedIn"/>

        <!-- Account Section (when not logged in; when logged in use header account button) -->
        <v-list-item v-if="!isLoggedIn" class="mobile-menu-section">
          <v-list-item-content>
            <v-list-item-title class="mobile-menu-title">{{ $t('layout.header.menu.account') }}</v-list-item-title>
            <div class="account-options">
              <v-btn
                v-if="!isLoggedIn"
                @click="goToAuth('signin')"
                text
                block
                class="account-btn"
              >
                <v-icon left>mdi-login</v-icon>
                {{ $t('layout.menu.login') }}
              </v-btn>
              <v-btn
                v-if="!isLoggedIn"
                @click="goToAuth('signup')"
                text
                block
                class="account-btn"
              >
                <v-icon left>mdi-account-plus</v-icon>
                {{ $t('layout.menu.signup') }}
              </v-btn>
            </div>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import urlUtil from '@/js/utils/urlUtil'
import { SUPPORTED_LOCALES } from '@/locales/locales'

export default {
  name: 'MobileMenu',
  props: {
    showOnDesktop: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    shouldShow() {
      return this.showOnDesktop || this.$vuetify.breakpoint.smAndDown
    },
    username() {
      return this.$store.getters['user/name'] || ''
    },
    organizationName() {
      return this.$store.getters['dashboard/activeOrganization']?.name || ''
    },
    currentLanguage() {
      return this.$i18n.locale
    },
    isLoggedIn() {
      return this.$store.getters['user/isLoggedIn']
    },
    languages() {
      return SUPPORTED_LOCALES.map(lang => ({
        value: lang.code,
        text: lang.name
      }))
    }
  },
  methods: {
    ...urlUtil,
    logout() {
      this.$store.dispatch('user/logout')
    },
    changeLang(lang) { 
      localStorage.setItem('lang', lang)
      const urlInDiffLanguage = urlUtil.getUrlInLocale(lang, urlUtil.getUrlWithoutLocale())
      window.open(urlInDiffLanguage, "_self")
    },
    goToAuth(type) {
      if (this.isLoggedIn) {
        this.$router.push(this.getLocalisedMyPagesUrl())
      } else if (type === 'signup') {
        this.$router.push(this.getLocalisedUrl('/signup'))
      } else if (type === 'signin') {
        this.$router.push(this.getLocalisedUrl('/login'))
      }
    },
    goToMyPages() {
      this.$router.push(this.getLocalisedMyPagesUrl())
    }
  }
}
</script>

<style scoped>
/* Mobile menu activator: wider so icon fits in background on mobile */
.mobile-menu-activator {
  min-width: 48px !important;
  min-height: 48px !important;
  width: 48px !important;
  height: 48px !important;
}

/* Mobile Menu Styling */
.mobile-menu {
  min-width: 280px;
  padding: 16px;
}

.mobile-menu-section {
  padding: 0 !important;
  margin-bottom: 16px;
}

.mobile-menu-section:last-child {
  margin-bottom: 0;
}

.mobile-menu-title {
  font-size: 14px !important;
  font-weight: 600 !important;
  color: var(--color-pallet-5) !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  margin-bottom: 12px !important;
}

.language-buttons {
  display: flex;
  gap: 8px;
}

.lang-btn {
  min-width: 60px !important;
  height: 36px !important;
  border: 1px solid #e0e0e0 !important;
  border-radius: 4px !important;
  font-weight: 500 !important;
}

.as-active-language {
  background: var(--color-pallet-1) !important;
  color: white !important;
  border-color: var(--color-pallet-1) !important;
}

.account-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.account-btn {
  justify-content: flex-start !important;
  padding: 12px 16px !important;
  border-radius: 8px !important;
  transition: all 0.2s ease !important;
}

.account-btn:hover {
  background: rgba(46, 139, 87, 0.1) !important;
}

.logout-btn {
  color: #dc3545 !important;
}

.logout-btn:hover {
  background: rgba(220, 53, 69, 0.1) !important;
}
</style>
